// DataTables v2 (ESM Vanilla) + Bootstrap 5
import DataTable from "datatables.net-bs5"
import "datatables.net-responsive-bs5"
import "datatables.net-buttons-bs5"
import "datatables.net-buttons/js/buttons.html5.min.js"
import "datatables.net-buttons/js/buttons.print.min.js"

// EXPÕE opcionalmente no window se quiser testar no console
window.DataTable = DataTable